import { FaTshirt } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaTshirt />,
    title: 'Basic Plan',
    price: 49,
    features: [
      'Priority Service',
      'Exclusive Discounts',
      'Special Offers',
      'Early Access to Promotions',
      'Monthly Newsletter',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaTshirt />,
    title: 'Premium Plan',
    price: 79,
    features: [
      'Express Delivery Options',
      'Stain Removal Services',
      'Monthly Subscription Box',
      'VIP Customer Support',
      'Seasonal Promotions',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaTshirt />,
    title: 'Elite Plan',
    price: 99,
    features: [
      'Premium Fabric Care',
      'Personalized Laundry Consultation',
      'Exclusive Event Invitations',
      'Customized Cleaning Preferences',
      'Priority Scheduling',
    ],
  },
];

export default pricing;